import React from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { mockServices } from '../mock';

const ServiceDetail = () => {
  const { slug } = useParams();
  const service = mockServices.find(s => s.slug === slug);

  if (!service) {
    return <Navigate to="/services" replace />;
  }

  // Map different hero images for different service types
  const getServiceImage = (serviceId) => {
    const imageMap = {
      'rpa': 'https://images.unsplash.com/photo-1485827404703-89b55fcc595e',
      'erp-crm': 'https://images.unsplash.com/photo-1460925895917-afdab827c52f',
      'app-dev': 'https://images.unsplash.com/photo-1498050108023-c5249f4df085',
      'staffing': 'https://images.unsplash.com/photo-1521737711867-e3b97375f902',
      'ai-strategy': 'https://images.unsplash.com/photo-1677442136019-21780ecad995',
      'gen-ai-llm': 'https://images.unsplash.com/photo-1620712943543-bcc4688e7485',
      'data-ml-ops': 'https://images.unsplash.com/photo-1551288049-bebda4e38f71',
      'ai-governance': 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85',
      'industry-ai': 'https://images.unsplash.com/photo-1504384308090-c894fdcc538d',
      'ai-automation': 'https://images.unsplash.com/photo-1518432031352-d6fc5c10da5a',
      'consulting': 'https://images.unsplash.com/photo-1557804506-669a67965ba0',
      'eor': 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40',
      'aor': 'https://images.unsplash.com/photo-1507679799987-c73779587ccf',
      'direct-sourcing': 'https://images.unsplash.com/photo-1522071820081-009f0129c71c',
      'global-talent': 'https://images.unsplash.com/photo-1488190211105-8b0e65b80b4e'
    };
    return imageMap[serviceId] || 'https://images.unsplash.com/photo-1497366216548-37526070297c';
  };

  return (
    <div className="dark-page">
      <section className="page-hero">
        <div className="hero-image-wrapper">
          <img 
            src={getServiceImage(service.id)} 
            alt={`${service.title} services`}
            className="hero-background-image"
          />
          <div className="hero-overlay"></div>
        </div>
        <h1 className="display-large">{service.title}</h1>
        <p className="body-large page-subtitle">{service.shortDesc}</p>
      </section>

      <section className="service-content-section">
        <div className="service-main-content">
          <h2 className="display-medium">Overview</h2>
          <p className="body-large">{service.description}</p>

          <div className="service-details-grid">
            <div className="detail-block">
              <h3 className="heading-2">Key Features</h3>
              <ul className="feature-list-detailed">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="body-medium">
                    <CheckCircle2 size={20} className="feature-icon" />
                    {feature}
                  </li>
                ))}
              </ul>
            </div>

            <div className="detail-block">
              <h3 className="heading-2">Business Benefits</h3>
              <ul className="feature-list-detailed">
                {service.benefits.map((benefit, idx) => (
                  <li key={idx} className="body-medium">
                    <CheckCircle2 size={20} className="feature-icon" />
                    {benefit}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="service-cta-block">
            <h3 className="heading-2">Ready to Get Started?</h3>
            <p className="body-medium">
              Let's discuss how {service.title.toLowerCase()} can benefit your organization.
            </p>
            <Link to="/contact" className="btn-primary">
              Request Consultation <ArrowRight size={20} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServiceDetail;